import React, { useEffect, useState } from 'react';
import { Button, LoadingIndicator } from '@components';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { TransformacaoBeneficioService } from '../../../services/transformacao-beneficio';

export const SaibaMaisSaudeFinanceiraPage = () => {
  const navigate = useNavigate();
  const [conteudoTexto, setConteudoTexto] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const service = new TransformacaoBeneficioService();

    service
      .obterSaibaMaisSaudeFinanceira()
      .then((res) => setConteudoTexto(res))
      .finally(() => setLoading(false));
  }, []);

  return loading ? (
    <LoadingIndicator />
  ) : (
    <>
      <Helmet>
        <title>Forluz - Saiba mais sobre saúde financeira</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>{conteudoTexto.Title}</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <div dangerouslySetInnerHTML={{ __html: conteudoTexto.Corpo }} />
        </div>
      </div>
    </>
  );
};
